<template>
  <div
    :class="['m-back-bar tw-relative tw-flex tw-items-center tw-justify-between', size, {
      'with-bg-image': isShowBgImage
    }]"
  >
    <a
      v-if="isShowBack"
      class="m-back"
      @click="handleBack"
    >
      <InlineSvg icon="~public/images/inline/arrowleft.svg" />
    </a>

    <slot>
      <template v-if="title">
        <h2
          slot="flex-left"
          class="m-back-title"
        >
          {{ title }}
        </h2>
      </template>
    </slot>

    <slot name="right" />
  </div>
</template>

<script>
export default {
  name: 'BackBar',
  props: {
    // 尺寸，默认为 normal，支持 large
    size: {
      type: String,
      default: 'normal'
    },
    isShowBgImage: {
      type: Boolean,
      default: true
    },
    isShowBack: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    // 是否自定义 back 事件
    custom: {
      type: Boolean,
      default: false
    },
    // back 指定的链接地址
    href: {
      type: String,
      default: ''
    },
    // vue-router 路由对象，用来做 back 跳转
    router: {
      type: Object,
      default: null
    }
  },
  methods: {
    handleBack() {
      if (this.custom) {
        // 自定义back事件提前
        this.$emit('back')
      } else if (this.router) {
        this.$router.push(this.router)
      } else if (this.$router) {
        this.$router.back()
      } else if (this.href) {
        location.href = this.href
      } else {
        window.goBack()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
[data-mode="light"] {
  .m-back-bar {
    background:#fff;
    color: #000;

    &.with-bg-image {
      background: linear-gradient(#FCDF82 -36%, #F8F8F8 100%);
    }

    ::v-deep a, .svg-icon {
      color: #000;
    }
  }
}
</style>

<style lang="scss">
@use "~wap/common/style/_mixin.scss";

.m-back-bar {
  box-sizing: border-box;
  padding: 0 10px 0 41px;
  background:#2b2b2b;
  color: #fff;
  font-size: 18px;

  &.with-bg-image {
    background: #1b1b1b url("../Header/images/bg-header.png") no-repeat;
    background-position: top -43px left 50%;
    background-size: 100% auto;
  }

  &.normal {
    height: 44px;
    line-height: 44px;
  }

  &.large {
    height: 56px;
    line-height: 56px;
  }

  .m-back {
    position: absolute;
    left: 10px;
    display: block;
    width: 16px;
    flex: none;
    padding: 0 5px;

    .inline-svg {
      width: 20px;
      margin-top: -3px;
    }
  }

  .m-back-title {
    width: 70%;
    flex: 1;
    font-size: 18px;

    @include mixin.ellipsis();
  }
}
</style>
